import ReorderDashboards from './ReorderDashboards';
export default ReorderDashboards;